var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"page"},[_c('Headline',{attrs:{"title":_vm.username,"icon":"mdi-account-outline"}}),_c('UserProfile',{attrs:{"targetUserUid":_vm.$store.state.base.user.uid},on:{"cancel":function($event){return _vm.$router.back()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }